import React, { useState } from 'react';
import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { Link } from 'react-router-dom';

import { TableBox } from 'retired/Box';
import { getAffiliationType } from 'containers/AffiliationsList/getAffiliationType';
import {
  AffiliationType,
  useAffiliationsByNonprofitQuery,
  useAffiliationsCountQuery,
} from 'generated/graphql';
import TablePaginationActions from 'retired/TablePaginationActions';
import { formatFullName } from 'utils/formatFullName';

type AffiliationsByNonprofit = {
  __typename?: 'Affiliation' | undefined;
  id: string;
  affiliationType?: AffiliationType | null | undefined;
  userId: string;
  User: {
    __typename?: 'BaseUser' | undefined;
    fullName: { first: string; last: string };
  };
}[];

const OrganizationAffiliationsTable = ({
  nonprofitId,
}: {
  nonprofitId: string;
}): React.ReactElement => {
  const [offset, setOffset] = useState(0);

  const { data, loading } = useAffiliationsByNonprofitQuery({
    variables: {
      offset,
      limit: 10,
      nonprofitId,
    },
  });

  const { data: count } = useAffiliationsCountQuery({
    variables: {
      nonprofitId,
    },
  });

  let affiliations: AffiliationsByNonprofit = [];

  if (data) {
    affiliations = data.affiliationsByNonprofit;
  }

  const goToPage = (__: unknown, pageNum: number): void => {
    setOffset(pageNum * 10);
  };
  return (
    <div
      style={{
        display: 'table',
        width: '100%',
      }}
    >
      <TableBox>
        {loading ? (
          <LinearProgress />
        ) : (
          <div
            style={{
              height: 4,
            }}
          />
        )}
        <Toolbar
          style={{
            marginTop: -4,
            justifyContent: 'space-between',
          }}
        >
          <Typography
            variant="h6"
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              textTransform: 'capitalize',
              marginRight: 10,
            }}
          >
            Affiliated Employees
          </Typography>
        </Toolbar>
        <Table>
          <TableHead>
            <TableRow>
              {['Name', 'Affiliation Type'].map((item) => (
                <TableCell key={item} size="medium">
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody
            style={
              loading
                ? {
                    opacity: 0.3,
                    cursor: 'wait',
                    pointerEvents: 'none',
                  }
                : null
            }
          >
            {affiliations?.length === 0 && !loading ? (
              <TableRow>
                <TableCell colSpan={3}>
                  <Typography
                    style={{
                      padding: '16px 0',
                    }}
                  >
                    There are no employees affiliated with this organization
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              affiliations?.map((affiliation) => (
                <TableRow key={affiliation.id}>
                  <TableCell>
                    <Link to={`/volunteers/${affiliation.userId}`}>
                      {formatFullName(affiliation?.User?.fullName)}
                    </Link>
                  </TableCell>
                  <TableCell>{getAffiliationType(affiliation?.affiliationType)}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TableCell
                size="medium"
                style={{
                  color: '#0000008a',
                  fontSize: '0.875rem',
                }}
              >
                Total: {count?.affiliationsCount || 0}
              </TableCell>
              <TablePagination
                count={count?.affiliationsCount || 0}
                rowsPerPage={10}
                page={offset / 10 || 0}
                rowsPerPageOptions={[]}
                onChangePage={goToPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableBox>
    </div>
  );
};

export default OrganizationAffiliationsTable;
